// extracted by mini-css-extract-plugin
module.exports = {"meadiaheadbox":"MediaCoverage_meadiaheadbox__hGIiX","medaimainbox":"MediaCoverage_medaimainbox__qTcrk","medaiTiles":"MediaCoverage_medaiTiles__mtXgK"};